var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminalBackArrowIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 20.5C31 20.8612 30.8551 21.2077 30.5972 21.4631C30.3394 21.7185 29.9896 21.862 29.6249 21.862L13.6924 21.862L19.596 27.7095C19.8389 27.9677 19.9712 28.3092 19.9649 28.662C19.9586 29.0149 19.8143 29.3515 19.5623 29.6011C19.3104 29.8506 18.9705 29.9936 18.6143 29.9998C18.258 30.006 17.9133 29.875 17.6526 29.6345L9.40215 21.4625C9.14464 21.2071 9 20.8609 9 20.5C9 20.1391 9.14464 19.7929 9.40215 19.5375L17.6526 11.3655C17.9133 11.125 18.258 10.994 18.6143 11.0002C18.9705 11.0064 19.3104 11.1494 19.5623 11.3989C19.8143 11.6485 19.9586 11.9851 19.9649 12.338C19.9712 12.6908 19.8389 13.0323 19.596 13.2905L13.6924 19.138L29.6249 19.138C29.9896 19.138 30.3394 19.2815 30.5972 19.5369C30.8551 19.7923 31 20.1388 31 20.5Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalBackArrowIconActive);
export default __webpack_public_path__ + "static/media/terminalBackArrowIconActive.0f7cbeae271b1524d2b6b578383ed9a1.svg";
export { ForwardRef as ReactComponent };